export const ORDER_STATES = Object.freeze({
  buyer_return_approved: { value: 'buyer_return_approved', displayName: 'Returned' },
  canceled_by_buyer: { value: 'canceled_by_buyer', displayName: 'Canceled' },
  canceled_by_seller: { value: 'canceled_by_seller', displayName: 'Canceled' },
  canceled_by_seller_review: { value: 'canceled_by_seller_review', displayName: 'Canceled' },
});

export const SHIPPED_STATES = Object.freeze({
  shipped_buyer: { value: 'shipped_buyer', displayName: 'Shipped' },
  shipped_goat: { value: 'shipped_goat', displayName: 'Shipped' },
  goat_received: { value: 'goat_received', displayName: 'Shipped' },
  goat_verifying: { value: 'goat_verifying', displayName: 'Shipped' },
  goat_verified: { value: 'goat_verified', displayName: 'Shipped' },
  goat_check: { value: 'goat_check', displayName: 'Shipped' },
  goat_prepackaged: { value: 'goat_prepackaged', displayName: 'Shipped' },
  goat_packaged: { value: 'goat_packaged', displayName: 'Shipped' },
  goat_stand_by: { value: 'goat_stand_by', displayName: 'Shipped' },
  goat_with_courier: { value: 'goat_with_courier', displayName: 'Shipped' },
});

export const SELLER_PACKAGING = 'seller_packaging';
export const SELLER_CONFIRMED = 'seller_confirmed';
export const SHIPPED_BUYER = 'shipped_buyer';
export const SOLD = 'sold';
export const BUYER_CONFIRMED = 'buyer_confirmed';
export const DELIVERED = 'delivered';
export const WITH_COURIER = 'with_courier';

export const PRINT_LABEL = 'Print label';
export const RE_PRINT_LABEL = 'Re-Print label';
export const PRINT_CUSTOMS_FORM = 'Print customs form';
export const GENERATING_LABEL = 'Generating label';
